import { render } from "./PlannedPaymentReportsPageList.vue?vue&type=template&id=b92771fe&scoped=true"
import script from "./PlannedPaymentReportsPageList.vue?vue&type=script&lang=ts"
export * from "./PlannedPaymentReportsPageList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-b92771fe"

export default script